import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';

const LinkButton = styled(LoadingButton)(({ theme }) => ({
  '&&&': {
    fontSize: 14,
    textTransform: 'none',
    color: theme.palette.secondary.main,
    display: 'inline-flex',
    alignItems: 'center',
    maxHeight: 37,
    gap: 0.5,
    padding: 0,
    minWidth: 0,
    fontWeight: 600,
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
      color: theme.palette.secondary.main,
    },
    '&.MuiButton-root': {
      color: theme.palette.secondary.main,
    },
    '&.MuiLoadingButton-loading': {
      color: 'grey',
      '& .openIcon': {
        display: 'none',
      },
      '& .MuiLoadingButton-loadingIndicator': {
        left: '145%',
      },
      '& .MuiCircularProgress-root': {
        left: '120%',
      },
    },
  },
}));

export default LinkButton;
